import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {

  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUNS]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].POST_FUEL_STATION_GUN]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/',
    requestOptions: {
      method: 'POST',
    },
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/:gunId/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_POPUP]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/:gunId/popup/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_PREVIEW]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/:gunId/preview/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PUT_FUEL_STATION_GUN]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/:gunId/',
    requestOptions: {
      method: 'PUT',
    },
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PATCH_FUEL_STATION_GUN]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/:gunId/',
    requestOptions: {
      method: 'PATCH',
    },
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].DELETE_FUEL_STATION_GUN]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/guns/:gunId/',
    requestOptions: {
      method: 'DELETE',
    },
  },
}
